var nameToSize = {
    xsmall: '0.75rem',
    small: '0.875rem',
    normal: '1rem',
    large: '1.5rem',
    xlarge: '2rem',
    xxlarge: '3rem'
};
export var getSize = function (size) {
    return nameToSize[size] ? nameToSize[size] : size;
};
